<template>
  <div>
    <template v-if="tooltip">
      <TooltipStandardV2 :text="tooltip" :arrowPosition="'top-center'" :vertical-offset="4">
        <div class="badge-list-item" :style="computedStyle">
          {{ text }}
        </div>
      </TooltipStandardV2>
    </template>
    <template v-else>
      <div class="badge-list-item" :style="computedStyle">
        {{ text }}
      </div>
    </template>
  </div>
  <div class="badge-list-item-separator"></div>
</template>
<script lang="ts" setup>
import TooltipStandardV2 from '@/design-system/atoms/TooltipStandardV2.vue'
import { computed } from 'vue'
type Props = {
  text: string
  color?: string
  children?: Props[]
}
const props = defineProps<Props>()
const tooltip = computed(() => {
  if (props.children && props.children.length > 0) {
    return props.children.map((child) => child.text).join('\n')
  }
  return undefined
})
const computedStyle = computed(() => {
  if (props.color) {
    return { 'background-color': props.color }
  }
  return { 'background-color': '#e0e0e0' }
})
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/variables.scss';
.badge-list-item {
  @include font-mixins.desktop-regular-label;
  cursor: default;
  display: inline-block;
  padding: 4px;
  border-radius: 4px;
}

.badge-list-item-separator {
  display: inline-block;
  width: 1pt;
  height: 16px;
  background-color: variables.$color-graph-gray;
}
.badge-list-item-separator:last-child {
  display: none; /* Remove separator for the last item */
}
</style>
